import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { handleServerError } from '@/utils/handle-server-error'
import { routeTree } from '../routeTree.gen'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // retry: (failureCount, error) => {
      //   // eslint-disable-next-line no-console
      //   if (import.meta.env.DEV) console.log({ failureCount, error })

      //   if (failureCount >= 0 && import.meta.env.DEV) return false
      //   if (failureCount > 3 && import.meta.env.PROD) return false

      //   return !(
      //     error instanceof AxiosError &&
      //     [401, 403].includes(error.response?.status ?? 0)
      //   )
      // },
      refetchOnWindowFocus: import.meta.env.PROD,
      staleTime: 45 * 1000, // 45s
    },
    mutations: {
      onError: (error) => {
        handleServerError(error)
      },
    },
  },
})
// This code is only for TypeScript
declare global {
  interface Window {
    //@ts-expect-error no idea why
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient
  }
}

// This code is for all users
window.__TANSTACK_QUERY_CLIENT__ = queryClient

export const router = createRouter({
  routeTree,
  defaultStructuralSharing: true,
  // context: { queryClient: queryClient, authState: null },
})
